import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import EventMore from '../Event/EventMore';
import xCal from '../../lib/calc';
import { requestGet } from '../../api/request';
import { SEARCH_BY_REGION } from '../../api/url';
import * as actions from '../../redux/actions';
import { ShowItemInSearch } from '../Partials/Helper';

const SearchByRegion = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const [searchParams, setSearchParams] = useSearchParams();

  const [event, setEvent] = useState({});
  const [currentPage, setCurrentPage] = useState(+searchParams.get('page') || 1);
  const [searchText, setSearchText] = useState(searchParams.get('q') || undefined);
  const [selectedSearchByDate, setSelectedSearchByDate] = useState(searchParams.get('date') || null);

  // Календарь
  const calendar = () => {
    const nameId = document.getElementById('date8');

    if (nameId) {
      xCal('date8', {
        id: 'cssworldru8', // Задать уникальный ID
        'class': 'xcalend', // CSS класс оформления внешнего вида
        hide: 0, // Не скрывать календарь
        x: 0, // Отключить кнопку закрытия календаря
        autoOff: 0, // Отключить автоматическое скрытие
        to: 'date8', // Разместить календарь внутри элемента с id=date8
        fn: '', // Вызвать функцию с указанным названием, в нее будет передан результат выбора
      });
    }
  };

  const getData = async () => {
    setLoader(true);
    const response = await requestGet(SEARCH_BY_REGION, {
      'page': currentPage,
      'searchText': searchText,
      'searchByDate': selectedSearchByDate,
      'lang_id': currentLanguage.id,
    });
    if (response.success) {
      setEvent(response.data);
      setLoader(false);
      calendar();
    } else {
      navigate('/');
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 1) {
      searchParams.set('page', +pageNumber);
    } else {
      searchParams.delete('page');
      setCurrentPage(1);
    }
    setSearchParams(searchParams);
  };

  const handleSearchText = (e) => {
    const { target } = e;
    setCurrentPage(1);
    if (target.value !== null && target.value !== '') {
      searchParams.set('q', target.value);
      searchParams.delete('page');
    } else {
      searchParams.delete('q');
    }
    setSearchParams(searchParams);
  };

  const handleSelectSearchByDate = () => {
    if (currentPage > 1) {
      setCurrentPage(1);
    }
    searchParams.delete('page');
    if (xCal.value !== null && xCal.value !== undefined) {
      searchParams.set('date', xCal.value);
    } else {
      searchParams.delete('search');
    }
    setSearchParams(searchParams);
  };

  const handleKeyPress = (e, value) => {
    if (e.key === 'Enter') {
      setSelectedSearchByDate(value);
    }
  };

  useEffect(() => {
    if (event.data) {
      dispatch(actions.adjustFontSize(fontSize));
    }
  });

  useEffect(() => {
    // Handle page url params;
    if (+searchParams.get('page') > 1) {
      setCurrentPage(+searchParams.get('page'));
    }
    // Handle search url params;
    if (searchParams.get('q')) {
      setSearchText(searchParams.get('q'));
    } else {
      setSearchText('');
    }
    // Handle date url params;
    if (searchParams.get('date')) {
      setSelectedSearchByDate(searchParams.get('date'));
    } else {
      setSelectedSearchByDate(null);
    }
  }, [searchParams]);

  useEffect(() => {
    if (searchText) {
      const delayDebounceFn = setTimeout(() => {
        setEvent({});
        getData();
      }, 200);
      return () => clearTimeout(delayDebounceFn);
    } else {
      getData();
    }
  }, [currentPage, searchText, selectedSearchByDate, currentLanguage]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-9">
          <div className="orders-search mt-4 ">
            <div className="search d-lg-block">
              <input
                className="search__input"
                type="text"
                onChange={handleSearchText}
                placeholder={dictionary.search}
                value={searchText}
              />

              <button type="button" className="search-button">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1016_9838)">
                    <path
                      d="M25.8333 23.3333H24.5167L24.05 22.8833C25.6833 20.9833 26.6667 18.5167 26.6667 15.8333C26.6667 9.85 21.8167 5 15.8333 5C9.85 5 5 9.85 5 15.8333C5 21.8167 9.85 26.6667 15.8333 26.6667C18.5167 26.6667 20.9833 25.6833 22.8833 24.05L23.3333 24.5167V25.8333L31.6667 34.15L34.15 31.6667L25.8333 23.3333ZM15.8333 23.3333C11.6833 23.3333 8.33333 19.9833 8.33333 15.8333C8.33333 11.6833 11.6833 8.33333 15.8333 8.33333C19.9833 8.33333 23.3333 11.6833 23.3333 15.8333C23.3333 19.9833 19.9833 23.3333 15.8333 23.3333Z"
                      fill="#333333"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1016_9838">
                      <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.000244141)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
          {loader === true ? (
            <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
              <div className="spinner-border text-success" role="status">
                <span className="sr-only" />
              </div>
            </div>
          ) : null}
          {event.data && event.data.length > 0 ? (
            <div>
              <div className="meetings-container">
                <ShowItemInSearch event={event} />
              </div>
              {event.last_page > 1
                ? (
                  <Pagination
                    activePage={currentPage || 1}
                    totalItemsCount={event.data ? event.total : 0}
                    onChange={(pageNumber) => handlePageChange(pageNumber)}
                    pageRangeDisplayed={14}
                    itemclassName=""
                    linkclassName=""
                    firstPageText={dictionary.pagination_prev}
                    lastPageText={dictionary.pagination_last}
                    prevPageText={dictionary.pagination_first}
                    nextPageText={dictionary.pagination_next}
                    innerClass="paginations d-lg-flex flex-wrap"
                    hideDisabled={true}
                  />
                ) : null }
            </div>
          ) : null}
        </div>
        <div className="col-lg-3 pl-lg-4 d-none d-lg-block">
          <div className="saidbar-content__title mt-3">
            <span>{dictionary.calendar}</span>
          </div>
          <div className="saidbar-calendar">
            <div className="calendar">
              <div
                id="date8"
                onClick={handleSelectSearchByDate}
                onKeyDown={(e) => {
                  handleKeyPress(e, xCal.value);
                }}
                role="button"
                tabIndex="0"
                aria-label="calendar"
              />
            </div>

            <div className="saidbar-calendar__button">
              <button
                type="button"
                className="button"
                onClick={() => {
                  setSelectedSearchByDate(null);
                  searchParams.delete('date');
                  setSearchParams(searchParams);
                  xCal.value = null;
                }}
              >
                {dictionary.restore}
              </button>
            </div>
          </div>
          <EventMore />
        </div>
      </div>
    </div>
  );
};

export default SearchByRegion;
